import {
  AutoraterLikertJustificationSuggestionRequest,
  AutoraterJustificationSuggestionRequest,
  AutoraterLikertJustificationSuggestionsResponse,
  AutoraterJustificationSuggestionsResponse,
} from '@scale/shared/types/chat';
import apiFetch from 'react-scale/lib/api-fetch';

export const fetchAutoraterJustificationSuggestions = async (
  payload: AutoraterJustificationSuggestionRequest,
): Promise<AutoraterJustificationSuggestionsResponse> => {
  return apiFetch<AutoraterJustificationSuggestionsResponse>(
    null,
    `internal/genai/autorater/v0/justification`,
    {
      body: payload,
      maxRetries: 2,
      method: 'POST',
      parseAndHandle: true,
      redirectOnUnauthorized: true,
    },
  );
};

export const fetchAutoraterLikertJustificationSuggestions = async (
  payload: AutoraterLikertJustificationSuggestionRequest,
): Promise<AutoraterLikertJustificationSuggestionsResponse> => {
  return apiFetch<AutoraterLikertJustificationSuggestionsResponse>(
    null,
    `internal/genai/autorater/v0/likert-justification`,
    {
      body: payload,
      maxRetries: 2,
      method: 'POST',
      parseAndHandle: true,
      redirectOnUnauthorized: true,
    },
  );
};
